export enum Continent {
  AM = 'AM',
  EU = 'EU',
  AS = 'AS',
}
